{
  "label": "user",
  "button": {
    "delete": "Remove the user",
    "create": "New user",
    "activate": "Activate the user",
    "deactivate": "Deactivate the user",
    "disabled": {
      "unauthorized": "Insufficient permissions to edit this user"
    }
  },
  "empty": "No users found",
  "confirmRemove": {
    "title": "User removal",
    "description": "The selected user \"{userName} {userFirstname}\" will be removed"
  },
  "form": {
    "userIdentity": {
      "title": "Information"
    },
    "userProfile": {
      "title": "Profile"
    },
    "userGroups": {
      "title": "Groups",
      "selectAllLabel": "Select all groups"
    },
    "tabs": {
      "information": "Information",
      "delegations": "Delegations"
    },
    "delegations": {
      "selectOrganization": "Select the organization",
      "selectProfile": "Select the profile",
      "noProfile": "No profile"
    }
  },
  "search": "Search by firstname or lastname",
  "userAccount": {
    "userInformations": {
      "title": "User information"
    },
    "password": {
      "title": "Password"
    },
    "language": {
      "title": "Language",
      "activeDirectoryWarning": "Language modification is not possible when active directory is enabled."
    },
    "certificate": {
      "title": "Certificate"
    },
    "instructions": {
      "informations": "Update your personal details here.",
      "email": "Manage your email.",
      "phone": "Add your phone number.",
      "password": "Update your password.",
      "language": "Choose the language in which you want to use LX CONNECT."
    },
    "forms": {
      "cancel": "Cancel",
      "certificateEmpty": "No certificate available",
      "certificateStatusDateFormat": "YYYY-MM-DD",
      "currentPassword": "Verify current password",
      "edit": "Edit",
      "email": "Email",
      "firstName": "First name",
      "generatedOn": "Generated on",
      "lastName": "Last name",
      "login": "Login",
      "newPassword": "New password",
      "organisationName": "Organization name",
      "phoneNumber": "Phone number",
      "profile": "Profile",
      "requestNewCertificate": "Request a new certificate",
      "sectors": "Sectors",
      "validate": "Validate",
      "validFrom": "Valid from",
      "validTo": "Valid to"
    }
  },
  "table": {
    "column": {
      "lastName": "Last name",
      "firstName": "First name",
      "profile": "Profile",
      "email": "Email",
      "groups": "Groups",
      "status": "Status"
    }
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "firstNameRequiredError": "The first name is required.",
  "lastNameRequiredError": "The last name is required.",
  "loginRequiredError": "The login is required.",
  "emailRequiredError": "Email is required.",
  "languageError": "The language is required.",
  "firstNameLengthError": "Length between 1 and 50 characters.",
  "firstNameFormatError": "Special characters allowed except at the beginning or the end --> [ -_.'].",
  "lastNameLengthError": "Length between 1 and 50 characters.",
  "lastNameFormatError": "Special characters allowed except at the beginning or the end --> [ -_.'].",
  "loginLengthError": "Length between 3 and 50 characters.",
  "loginFormatError": "Lower case only. Special characters allowed except at the beginning or the end --> [!$%&'*+=?^`{'{'}{'|'}{'}'}~{'@'}_.-].",
  "emailFormatError": "Email format invalid.",
  "create": {
    "title": "User creation",
    "information": "Information",
    "saveButton": "Create the user",
    "confirm": {
      "title": "User creation"
    }
  },
  "lastName": "Last name",
  "firstName": "First name",
  "addUser": {
    "button": "New user"
  },
  "login": "Login",
  "email": "Email",
  "language": "Language",
  "profile": "Profile",
  "profilePlaceholder": "Search by name of profile",
  "profileRequired": "The profile is required.",
  "groups": "Groups",
  "groupsSearchPlaceholder": "Search by group name",
  "sectors": "Sectors",
  "update": {
    "title": "Modify user",
    "confirm": {
      "title": "Edit the user"
    }
  },
  "confirm": {
    "message": "Do you confirm cancelling the operation? All unsaved data will be lost."
  },
  "filters": {
    "selectionQuickFilters": {
      "allUsers": "All users",
      "selectedUsers": "Selected users",
      "unselectedUsers": "Unselected users"
    }
  },
  "read": {
    "title": "View user"
  }
}
